import Vue from 'vue';
const vTooltip = () => import(/* webpackPrefetch: true, webpackChunkName: 'v-tooltip' */ 'v-tooltip');

(async() => {
    const { VTooltip, VPopover, VClosePopover } = await vTooltip();
    Vue.directive('tooltip', VTooltip);
    Vue.directive('close-popover', VClosePopover);
    Vue.component('VPopover', VPopover);
})();
